const rawApiUrl = process.env.REACT_APP_API_URL?.trim();

if (!rawApiUrl) {
    throw new Error(
        "Missing environment variable REACT_APP_API_URL. Please set it in .env before starting or building the frontend."
    );
}

export const API_BASE_URL = rawApiUrl.replace(/\/+$/, "");
